import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const { name, email, phone, message } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!name || !email || !phone || !message) {
      toast.error("All fields except plot type are required.");
      return false;
    }

    if (name.length > 100) {
      toast.error("Name must be under 100 characters.");
      return false;
    }

    if (email.length > 50 || !emailRegex.test(email)) {
      toast.error("Please enter a valid email (max 50 characters).");
      return false;
    }

    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return false;
    }

    return true;
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    let { name, value } = e.target;

    if (["name", "email", "phone"].includes(name)) {
      value = value.replace(/^\s+/, "");

      value = value.replace(/\s{2,}/g, " ");
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (
    e: React.FocusEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    let { name, value } = e.target;

    if (["name", "email", "phone"].includes(name)) {
      value = value.trim();
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      gt_name: formData.name,
      gt_email: formData.email,
      gt_mobile: formData.phone,
      gt_plottype: formData.interest || null,
      gt_msg: formData.message,
    };

    setIsSubmitting(true);

    try {
      const res = await axios.post(`${API_BASE}/api/getintouch/add`, payload);
      if (res.data.success) {
        toast.success("Thanks for getting in touch. We will contact you soon!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          interest: "",
          message: "",
        });
      } else {
        toast.error(res.data.message || "Failed to send message.");
      }
    } catch (err) {
      toast.error("An error occurred while sending the message.");
    } finally {
      setIsSubmitting(false); // Stop loader
    }
  };

  return (
    <FrontendLayout>
      <ToastContainer />
      <section className="flat-title style-2 mb-4 tf-spacing-1 inner-banner">
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>Contact</li>
                </ul>
                <h5 className="mt-3">Contact</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="tf-container py-5">
        <div className="row">
          <div className="col-lg-7 pb-5 tf-spacing-1">
            <form onSubmit={handleSubmit} className="form-contact form">
              <div className="heading-section">
                <h3 className="title">We Would Love to Hear From You</h3>
                <p className="text-1">
                  Feel free to connect with us by submitting this form.
                </p>
              </div>

              <div className="row form">
                <div className="col-lg-6 pb-5">
                  <div className="box-fieldset">
                    <label htmlFor="name">Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your name"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 pb-5">
                  <div className="box-fieldset">
                    <label htmlFor="email-contact">Email:</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      id="email-contact"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 pb-5">
                  <div className="box-fieldset">
                    <label htmlFor="phone">Phone number:</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your phone number"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 pb-5">
                  <div className="box-fieldset">
                    <label htmlFor="interest">
                      What are you interested in?
                    </label>
                    <select
                      className="form-select nice-select"
                      name="interest"
                      id="interest"
                      value={formData.interest}
                      onChange={handleChange}
                    >
                      <option value="">Select Plot Type</option>
                      <option value="Commercial">Commercial</option>
                      <option value="Residential">Residential</option>
                      <option value="Agricultural">Agricultural</option>
                      <option value="Industrial">Industrial</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="box-fieldset">
                    <label htmlFor="message">Your Message:</label>
                    <textarea
                      name="message"
                      className="form-control"
                      cols={30}
                      rows={10}
                      placeholder="Message"
                      id="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="send-wrap">
                <button
                  className="tf-btn bg-color-primary fw-7 pd-8"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>

          <div className="col-lg-5 pb-5">
            <div className="box-contact">
              <div className="heading-section mb-48">
                <h3 className="title mt-5">
                  We provide the most suitable and quality plots.
                </h3>
              </div>
              <ul className="list-info">
                <li>
                  <div className="icon sec1 p-3 rounded">
                    <i className="bi bi-pin-map"></i>
                  </div>
                  <div className="content">
                    <div className="sub">Orimark Properties</div>
                    <p>
                      Plot - 2, Saheed Nagar,
                      <br /> Bhubaneswar-751007, Odisha, India
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icon sec2 p-3 rounded">
                    <i className="bi bi-telephone-outbound"></i>
                  </div>
                  <div className="content">
                    <div className="sub">Contact us</div>
                    <p>8847837744</p>
                  </div>
                </li>
                <li>
                  <div className="icon sec3 p-3 rounded">
                    <i className="bi bi-envelope-at"></i>
                  </div>
                  <div className="content">
                    <div className="sub">Email us</div>
                    <a href="mailto:info@orimark.com">info@orimark.com</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </FrontendLayout>
  );
};

export default Contact;
